
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import wx from 'weixin-js-sdk'
import global_ from './global'

export default {
components: {
Card,
XHeader,
XButton
},
name: 'skillPhoto',
data() {
return {
company: '',
starttime: '',
endtime: '',
title: '',
img1: '/static/img/skill.png',
img2: '/static/img/skill.png',
skillphoto: [],
account: '',
sequence: '',
imgflag: false,
imgflag1: false,
result: localStorage.getItem('result'),
arr: [{'value': ''}],
brr: [{'value': ''}]
}
},
methods: {
confirm() {
this.$router.push({name: 'expertInfo'})
},
upload(event) {
var name = event.currentTarget.name
if (this.result === 'TO_BE_APPROVE') {
this.uploadImg(name)
} else {
this.$vux.confirm.show({
title: '',
content: '修改信息需要重新进行审核,将会影响接单等功能,确认修改？',
onConfirm: () => {
this.uploadImg(name)
}
})
}
},
uploadImg(name) {
var app = this
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
wx.chooseImage({
count: 1, // 默认9
sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: (res) => {
var localIds = res.localIds 
if (name === 'image1') {
app.img1 = localIds[0]
} else {
app.img2 = localIds[0]
}
if (window.__wxjs_is_wkwebview) {
wx.getLocalImgData({
localId: localIds[0],
success: (res) => {
if (name === 'image1') {
app.img1 = res.localData
} else {
app.img2 = res.localData
}
}
})
}
setTimeout(
wx.uploadImage({
localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: function (res) {
app.$vux.loading.show()
var serverId = res.serverId 
var userInfo
var obj = {
photo: []
}
if (name === 'image1') {
obj.photo.push(serverId)

AjaxPlugin.$http.post('/api/v1/photos/wechat', obj, header)
.then(res => {
var info = {
'origin': '',
'thumb': ''
}
for (var i in res.data) {
info.origin = res.data[i].origin
info.thumb = res.data[i].thumb
}
app.skillphoto = []
app.skillphoto.push(info)
var arr = []
AjaxPlugin.$http.get('api/v1/photos?path=' + app.skillphoto[0].thumb, header)
.then(res => {
arr.push(res.data)
})
app.arr = arr

userInfo = {
sequence: app.sequence,
skillphoto: app.skillphoto
}
app.submitImage(userInfo)
})
.catch((error) => {
if (error.response) {
app.$vux.loading.hide()
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
} else {
app.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
}
} else {
app.$vux.loading.hide()
app.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
console.log('Error', error.message)
}
})
} else {
obj.photo.push(serverId)
AjaxPlugin.$http.post('/api/v1/photos/wechat', obj, header)
.then(res => {
var info = {
'origin': '',
'thumb': ''
}
for (var i in res.data) {
app.skillphoto[1].origin = res.data[i].origin
app.skillphoto[1].thumb = res.data[i].thumb
}

var brr = []
AjaxPlugin.$http.get('api/v1/photos?path=' + app.skillphoto[1].thumb, header)
.then(res => {
brr.push(res.data)
})
app.brr = brr

userInfo = {
sequence: app.sequence,
skillphoto: app.skillphoto
}
app.submitImage(userInfo)
})
}
}
}), 100)
}
})
},
submitImage(userInfo) {
var app = this
var opid = localStorage.getItem('userid')
var head = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
app.$http.put('/api/v1/experts/' + opid + '/photo', userInfo, head)
.then(function (response) {
app.$vux.loading.hide()
app.$vux.alert.show({
title: '',
content: '图片保存成功',
onHide() {
app.sequence += 1
}
})
})
.catch(function (error) {
if (error.response) {
app.$vux.loading.hide()
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
} else {
app.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
}
} else {
app.$vux.loading.hide()
app.$vux.alert.show({
title: '',
content: '服务器错误，请稍后重试'
})
console.log('Error', error.message)
}
})
}
},
mounted() {




setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
this.$http.get('static/config.json').then(response => {
var config = response.data
if (isiOS) {
url = config.host + global_.entryUrl
} else {
url = config.host + app.$route.path
}
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then(function (response) {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi'] 
})
wx.error(function (res) {
alert(res.errMsg)
})
})
.catch(function (error) {
alert('服务器错误，请稍后重试')
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
},
beforeRouteEnter(to, from, next) {

let expertdata = localStorage.getItem('expertdata')
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
if (expertdata != null) {
var data = JSON.parse(expertdata)
if (data) {
next(vm => {
vm.skillphoto = data.skillphoto
vm.account = data.account
vm.sequence = data.sequence
console.log(data.skillphoto)
if (vm.skillphoto.length === 1) {
var arr = []
vm.imgflag = true
vm.$vux.loading.show()
AjaxPlugin.$http.get('api/v1/photos?path=' + data.skillphoto[0].thumb, header)
.then(res => {
arr.push(res.data)
vm.$vux.loading.hide()
})
vm.arr = arr
} else if (vm.skillphoto.length === 2) {
var arr = [], brr = []
vm.$vux.loading.show()
vm.imgflag = true
vm.imgflag1 = true
AjaxPlugin.$http.get('api/v1/photos?path=' + data.skillphoto[0].thumb, header)
.then(res => {
arr.push(res.data)
vm.$vux.loading.hide()
})
vm.arr = arr
AjaxPlugin.$http.get('api/v1/photos?path=' + data.skillphoto[1].thumb, header)
.then(res => {
brr.push(res.data)
vm.$vux.loading.hide()
})
vm.brr = brr
}
})
}
} else {
next({
path: '/'
})
}

},
beforeRouteLeave(to, from, next) {
if (to.name === 'expertInfo') {
let expertdata = localStorage.getItem('expertdata')
if (expertdata != null) {
var data = JSON.parse(expertdata)
data.skillphoto = this.skillphoto
data.sequence = this.sequence
expertdata = JSON.stringify(data)
localStorage.setItem('expertdata', expertdata)
}
} else {
localStorage.removeItem('expertdata')
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/skillPhoto.vue